import { faUserCheck } from '@fortawesome/pro-light-svg-icons/faUserCheck';
import React from 'react';
import { handleClick } from './helper';
import NavLink from './NavLink';
import * as styles from './styles.module.scss';

const Overview = ({
  isActive,
  setActive,
  dataLinkId,
}: {
  isActive?: boolean;
  setActive?: (ev: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
  dataLinkId: string;
}) => {
  const iconLinkContainerClasses = `${styles.LeftNavIconLinkContainer} ${styles.IconLinkContainer}`;

  const overviewLinkClassname = `${styles.LinkRight} ${styles.OverviewLink} ${
    isActive ? styles.Active : ''
  }`;

  const onClick = (ev: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    handleClick(ev, setActive);
  };

  const iconClass = `${styles.Icon} ${isActive ? styles.Active : ''}`;

  return (
    <NavLink
      dataLinkId={dataLinkId}
      icon={faUserCheck}
      iconClassName={iconClass}
      iconContainerClassName={iconLinkContainerClasses}
      textClassName={overviewLinkClassname}
      copy="Overview"
      onClick={onClick}
    />
  );
};

export default Overview;
